(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userZipSearch', ['SearchService', UserZipSearchFn]);

    /* user zip search directive */
    function UserZipSearchFn(SearchService) {

        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                detail: '='
            },
            templateUrl: '/app/users/templates/user-zip-search.template.html'            
        };
        return directive;

        function link(scope, element) {

            /* search for zipcodes and locations */
            scope.search = function (searchValue) {
                return SearchService.searchZipCodes(searchValue).then(function (result) {
                    return result;
                });
            };

            /* set new location if zip change */
            scope.zipCodeChanged = function (item, model, label) {
                if (!item) { return; }
                // set location in input
                scope.detail.location = item.location;
                scope.detail.zipCode = label;
            };
        } // link

    }

})();